import React from 'react';
import { useOutletContext } from 'react-router-dom';
import TodoList from '../../components/Planner/TodoList';

export default function ToDoListSection() {
  const { project, projectId } = useOutletContext();

  const projIdForFilter = project?.id ?? project?.projectId ?? projectId ?? '';
  const projName = project?.projectNickname || project?.name || '';

  return (
    <TodoList
      initialProjectId={String(projIdForFilter)}
      projectName={projName}
      hideProjectTitleProjectPill={false}
      hideProjectSelector={true}
    />
  );
}
